<template>
  <RepositoryWrapper>
    <template #default="{ postfixIcon }">
      <DSSidebarItem
        label="Repositories"
        :icon="FolderGit2Icon"
        class="relative"
        data-refid="navbarRepositories"
        :is-mobile
        @click="handleOpenRepositories"
      >
        <template
          v-if="postfixIcon"
          #badge="{ collapsed }"
        >
          <DSTooltip>
            <DSTooltipTrigger as-child>
              <div
                class="flex items-center justify-center rounded-full ml-auto bg-primary-foreground/70"
                :class="collapsed ? 'absolute -top-0.5 -right-1.5 size-4 [&>svg]:size-2.5' : 'size-5 -mr-1 [&>svg]:size-3'"
              >
                <component
                  :is="postfixIcon"
                  aria-hidden="true"
                  class="text-primary"
                />
              </div>
            </DSTooltipTrigger>
            <DSTooltipContent>Current repository has collaborators</DSTooltipContent>
          </DSTooltip>
        </template>
      </DSSidebarItem>
    </template>
  </RepositoryWrapper>
</template>

<script setup lang="ts">
import { markRaw } from 'vue'

import { useModalsStore } from '@/store/modals'

import { FolderGit2Icon } from '@lucide/vue'
import { DSSidebarItem, DSTooltip, DSTooltipContent, DSTooltipTrigger } from '@ds'
import Repositories from '@/modules/modals/Repositories/List/Repositories.vue'
import RepositoryWrapper from '@/modules/modals/Repositories/RepositoryWrapper.vue'

defineProps<{
  isMobile?: boolean
}>()

const emit = defineEmits<{
  (e: 'click'): void
}>()

const modalsStore = useModalsStore()

const handleOpenRepositories = () => {
  const modalInstance = modalsStore.init('repositories', markRaw(Repositories))
  modalInstance?.open(modalsStore.getZIndex(), {})
  emit('click')
}
</script>
